import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import Separator from './basic/separator';
import { toggleAuthMode } from '../services/auth0';
import { translate } from '~/services/translate';
import analytics from '../services/amplitude';
import { MOBILE_THRESHOLD } from '../core/constants';
import { ColumnFlex } from '~/components/basic/containers';

const Container = styled(ColumnFlex)`
  font-size: 13px;
  width: 100%;
  max-width: 468px;
  align-items: center;
  position: absolute;
  top: 540px;
  left: 0;
  @media screen and (max-width: ${MOBILE_THRESHOLD}px) {
    padding: 0;
    top: 575px;
  }
`;

const FullWidthSeparator = styled(Separator)`
  display: flex;
  margin-bottom: 16px;
  width: 100%;

  @media screen and (max-width: ${MOBILE_THRESHOLD}px) {
    padding: 0;
    margin-bottom: 8px;
  }
`;

const LabelContainer = styled.div`
  display: flex;
  color: ${({ theme }) => theme.lightGray};
  margin: auto;
  line-height: 20px;
  cursor: pointer;
  
  @media screen and (max-width: ${MOBILE_THRESHOLD}px) {
    line-height:48px;
  }
`;

const SwitchAuthModeLink = styled.div`
  color: ${({ theme }) => theme.lightBlue};
  font-weight: 600;
  display: flex;
  font-size: 13px;
`;

const Footer = ({ onSwitchMode, isSignUp }) => {
  const onAuthModeChanged = () => {
    toggleAuthMode();
    analytics.trackEvent(analytics.EVENT_NAMES.SWITCH_AUTH_MODE);
    onSwitchMode();
  }

  return (
    <Container>
      <FullWidthSeparator />
      <LabelContainer onClick={onAuthModeChanged}>{isSignUp ? translate('existing_account') : translate('new_user')}&nbsp;
        <SwitchAuthModeLink>
          {isSignUp ? translate('login') : translate('sign_up')}
        </SwitchAuthModeLink>
      </LabelContainer>
    </Container>
  );
}

Footer.propTypes = {
  onSwitchMode: PropTypes.func,
  isSignUp: PropTypes.bool,
}

export default Footer;